import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { formatMoney, formatNumber } from '../../common/helpers';
import useFetch from '../../common/useFetch';
import CreditTransferService from '../../domain/CreditTransferService';
import { PrizeDistributorTypes } from '../../domain/Models';
import PrizeDistributionService from '../../domain/PrizeDistributionService';
import PrizeDistributorService from '../../domain/PrizeDistributorService';
import TicketIssuanceService from '../../domain/TicketIssuanceService';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import Breadcrumbs from '../Common/Breadcrumbs';
import { Pager, SearchInput, TableLoader, useDataframe } from '../Common/Dataframe';
import DateTime from '../Common/DateTime';
import Loader from '../Common/Loader';
import TicketNumber from '../Tickets/TicketNumber';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var PrizeDistribution = function (_a) {
    var _b;
    var match = _a.match;
    var t = useTranslation()[0];
    var _c = useFetch(function (config) { return PrizeDistributorService.getPrizeDistributor(match.params.prizeDistributor, config); }), prizeDistributor = _c.data, getPrizeDistributor = _c.get;
    var _d = useFetch(function (config) { return PrizeDistributionService.getPrizeDistribution(match.params.prizeDistribution, config); }), prizeDistribution = _d.data, getPrizeDistribution = _d.get;
    useEffect(function () {
        getPrizeDistributor();
        getPrizeDistribution();
    }, []);
    if (!prizeDistributor || !prizeDistribution) {
        return React.createElement(Loader, null);
    }
    var distributionComponents = (_b = {},
        _b[PrizeDistributorTypes.Credit] = CreditDistribution,
        _b[PrizeDistributorTypes.Ticket] = TicketDistribution,
        _b);
    var DistributionComponent = distributionComponents[prizeDistributor.driver];
    return React.createElement(React.Fragment, null,
        React.createElement(Breadcrumbs, null,
            React.createElement(Link, { to: "/prize-distributors" }, t('prize_distribution')),
            React.createElement(Link, { to: "/prize-distributors/".concat(prizeDistributor.id) }, prizeDistributor.title)),
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') },
                React.createElement(DateTime, { date: prizeDistribution.created_at }))),
        React.createElement(DistributionComponent, { prizeDistributor: prizeDistributor, prizeDistribution: prizeDistribution }));
};
var CreditDistribution = function (_a) {
    var prizeDistributor = _a.prizeDistributor, prizeDistribution = _a.prizeDistribution;
    var t = useTranslation()[0];
    var user = useContext(UserContext).user;
    var dataframe = useDataframe(function (config) {
        config.params = config.params || {};
        config.params.credit_distribution = prizeDistribution.distribution_id;
        return CreditTransferService.getCreditTransfers(config);
    }, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: gs('row', 'mb-4') },
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h3", null, formatMoney(prizeDistribution.distribution.net_amount)),
                t('net_amount')),
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h3", null, formatMoney(prizeDistribution.distribution.tax_amount)),
                t('tax_amount')),
            (user.isManager() || user.isFinance()) && React.createElement("div", { className: gs('col-md-6', 'text-right') },
                React.createElement("span", { className: gs('text-small mr-4') },
                    t('password'),
                    ": ",
                    prizeDistribution.distribution.password),
                React.createElement("a", { href: "/api/credit_distributions/".concat(prizeDistribution.distribution.id, "/download"), className: gs('btn', 'btn-secondary', 'btn-sm'), download: true },
                    React.createElement(FontAwesomeIcon, { icon: "download" }),
                    ' ',
                    t('download')))),
        React.createElement("div", { className: gs('w-50') },
            React.createElement(SearchInput, { dataframe: dataframe })),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '13%' } }, t('draw')),
                    React.createElement("th", { style: { width: '20%' } }, t('ticket')),
                    React.createElement("th", { style: { width: '12%' } }, t('prize')),
                    React.createElement("th", { style: { width: '20%' } }, t('creditor_name')),
                    React.createElement("th", { style: { width: '20%' } }, t('creditor_iban')),
                    React.createElement("th", { style: { width: '15%' } }, t('net_amount')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 6 }),
                dataframe.getData().map(function (creditTransfer) { return React.createElement("tr", { key: creditTransfer.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/draws/".concat(creditTransfer.won_prize.participation.draw.id) }, creditTransfer.won_prize.participation.draw.title)),
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/tickets/".concat(creditTransfer.won_prize.participation.ticket.id) },
                            React.createElement(TicketNumber, { number: creditTransfer.won_prize.participation.ticket.number }))),
                    React.createElement("td", null, creditTransfer.won_prize.prize.title),
                    React.createElement("td", null, creditTransfer.creditor_name),
                    React.createElement("td", null, creditTransfer.creditor_iban),
                    React.createElement("td", null, formatMoney(creditTransfer.net_amount))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
var TicketDistribution = function (_a) {
    var prizeDistributor = _a.prizeDistributor, prizeDistribution = _a.prizeDistribution;
    var t = useTranslation()[0];
    var dataframe = useDataframe(function (config) {
        config.params = config.params || {};
        config.params.ticket_distribution = prizeDistribution.distribution_id;
        return TicketIssuanceService.getTicketIssuances(config);
    }, {
        perPage: 10
    });
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: gs('row', 'mb-4') },
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h3", null, formatNumber(prizeDistribution.won_prizes_count * prizeDistribution.distribution.quantity)),
                t('distributed_tickets'))),
        React.createElement("div", { className: gs('w-50') },
            React.createElement(SearchInput, { dataframe: dataframe })),
        React.createElement("table", { className: gs('table-overview', 'mt-4', { loading: dataframe.isLoading() }) },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { style: { width: '18%' } }, t('draw')),
                    React.createElement("th", { style: { width: '23%' } }, t('ticket')),
                    React.createElement("th", { style: { width: '18%' } }, t('prize')),
                    React.createElement("th", { style: { width: '18%' } }, t('distributed_draw')),
                    React.createElement("th", { style: { width: '23%' } }, t('distributed_ticket')))),
            React.createElement("tbody", null,
                React.createElement(TableLoader, { dataframe: dataframe, columns: 5 }),
                dataframe.getData().map(function (ticketIssuance) { return React.createElement("tr", { key: ticketIssuance.id },
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/draws/".concat(ticketIssuance.won_prize.participation.draw.id) }, ticketIssuance.won_prize.participation.draw.title)),
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/tickets/".concat(ticketIssuance.won_prize.participation.ticket.id) },
                            React.createElement(TicketNumber, { number: ticketIssuance.won_prize.participation.ticket.number }))),
                    React.createElement("td", null, ticketIssuance.won_prize.prize.title),
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/draws/".concat(ticketIssuance.participation.draw.id) }, ticketIssuance.participation.draw.title)),
                    React.createElement("td", null,
                        React.createElement(Link, { to: "/tickets/".concat(ticketIssuance.participation.ticket.id) },
                            React.createElement(TicketNumber, { number: ticketIssuance.participation.ticket.number })))); }))),
        dataframe.getPageCount() > 1 && React.createElement("div", { className: gs('mt-4') },
            React.createElement(Pager, { dataframe: dataframe })));
};
export default withRouter(PrizeDistribution);
